// extracted by mini-css-extract-plugin
export default {"component-animate":"b1bVDa","rotation":"c1bVDa"};